import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../User/User.scss";
import "./About.scss";
import Button from "../common/Button";
import { LocalStorageKeys } from "../../models/LocalStorageKeys";
import UserHeading from "../User/UserHeading";

export default function About() {
    const navigate = useNavigate();

    function navigateHome() {
        navigate(`/matchmaking`, { replace: true });
    }

    const location = useLocation();
    const hasToken = !!localStorage.getItem(LocalStorageKeys.TOKEN_KEY);

    useEffect(() => {
        if (hasToken && location.pathname === '/') {
            navigate('/matchmaking', { replace: true });
        }
    }, [hasToken, navigate, location.pathname]);

    function onPlay() {
        if (hasToken) {
            navigate('/matchmaking');
        } else {
            navigate('/new');
        }
    }

    return (
        <div className="about">
            <UserHeading text="" onClose={hasToken ? navigateHome : undefined} />

            <h1>A game of storytelling and imagination</h1>

            <div className="about_actions">
                <Button text="Play" onClick={onPlay} ignoreConnection={true} />
            </div>

            <div className="about_content">


                <img src="screens/screen1.webp" alt="screen1" />
                <img src="screens/screen2.webp" alt="screen2" />
                <img src="screens/screen3.webp" alt="screen3" />
                <img src="screens/screen4.webp" alt="screen4" />
                <img src="screens/screen5.webp" alt="screen5" />
                <img src="screens/screen6.webp" alt="screen6" />
                <img src="screens/screen7.webp" alt="screen7" />

                <img src="screens/screen9.webp" alt="screen9" />
                <img src="screens/screen10.webp" alt="screen10" />
                <img src="screens/screen11.webp" alt="screen11" />

                <img src="screens/screen13.webp" alt="screen13" />
                <img src="screens/screen14.webp" alt="screen14" />

                <img src="screens/screen24.webp" alt="screen24" />
                <img src="screens/screen23.webp" alt="screen23" />

                <img src="screens/screen15.webp" alt="screen15" />
                <img src="screens/screen16.webp" alt="screen16" />

                <img src="screens/screen21.webp" alt="screen21" />
                <img src="screens/screen22.webp" alt="screen22" />

            </div>
            <div className="about_actions">
                <Button text="Play" onClick={onPlay} ignoreConnection={true} />
            </div>
            <br />
            <a href="mailto:gdainti@proton.me" className="contact-dev">contact dev</a>
        </div>
    );
}